// src/services/auth_service.js
import { auth } from '@/firebase';
import {
  sendPasswordResetEmail,
  verifyPasswordResetCode,
  confirmPasswordReset
} from 'firebase/auth';

function assertAuthorizedDomain(url) {

  console.debug('assertAuthorizedDomain', url);
  const host = window.location.hostname;
  if (!host) {
    console.warn('Hostname introuvable. Vérifie ton environnement.');
  }
}


export async function requestPasswordReset(email) {
  assertAuthorizedDomain(window.location.origin);

  const actionCodeSettings = {
    //url: `${window.location.origin}/reset-password`,
    url: `${origin}/#/reset-password`,
    handleCodeInApp: true
  };

  try {
    return await sendPasswordResetEmail(auth, email, actionCodeSettings);
  } catch (e) {
    console.error('requestPasswordReset error', e);
    throw e;
  }
}

export async function verifyResetCode(oobCode) {
  return verifyPasswordResetCode(auth, oobCode);
}

export async function applyNewPassword(oobCode, newPassword) {
  await confirmPasswordReset(auth, oobCode, newPassword);
  return true;
}
